import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import UseContentRedactionsQuery, {
	type useContentRedactionsQuery$data,
	type useContentRedactionsQuery$variables,
} from './hooks/__generated__/useContentRedactionsQuery.graphql.ts';
import type { GraphQLError } from 'graphql';

interface PreloadRedactionsQueriesI {
	contentId: string;
	canUpdateContent: boolean;
}

export const preloadRedactionsQueries = async ({
	contentId,
	canUpdateContent,
}: PreloadRedactionsQueriesI): Promise<
	| {
			data: useContentRedactionsQuery$data | null;
			errors?: ReadonlyArray<GraphQLError>;
			hasErrors: boolean;
	  }
	| undefined
> => {
	if (!contentId || !canUpdateContent) {
		return;
	}

	return query<useContentRedactionsQuery$data, useContentRedactionsQuery$variables>({
		query: UseContentRedactionsQuery,
		variables: { contentId },
		errorPolicy: 'all',
	});
};
